export const DASHBOARD_URL = "dashboard";
export const EXTENDED_VIEW_WIDTH = 768;
export const MOBILE_WIDTH = 430;
export const PAGE_COUNT = 10;

export const PAYMENT_ACTIVITY_WIDET_COUNT = 6;

export const ACH = "ach";
export const CARD = "card";
export const EWALLET = "eWallet";
export const LOCKBOX = "lockbox";

export enum paymentAmountType {
  due_amount = 2,
  other_due_amount = 3,
  other = 1,
  locked_due_amount = 4,
}

export enum recurrenceScheduleType {
  due_date = 2,
  custom = 1,
}

export const ERROR_TYPES = {
  ACCESS_DENIED: "access_denied",
  NOT_FOUND: "not_found",
  CLIENT_NOT_FOUND: "client_not_found",
  CONFIGURATION_ERROR: "configuration_failed",
  UNAUTHORIZED: "unauthorized",
};

export enum AccountAttributes {
  None = 0,
  ReadOnly = 1 << 0, // 1
  EnableACH = 1 << 1, // 2
  EnableCard = 1 << 2, // 4
  EnableEWallet = 1 << 3, // 8
}

export const GOOGLE_PAY_ENV = import.meta.env.REACT_APP_GOOGLE_PAY_ENV;
